var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useLocalStorage } from 'usehooks-ts';
import { useQuery } from '@tanstack/react-query';
import useMultiTokenData from './useMultiTokenData';
export default function useListedTokenData() {
    var _this = this;
    var _a = useLocalStorage('listedTokens', []), listedTokenLC = _a[0], setListedTokensLC = _a[1];
    var query = useQuery({
        queryKey: ['listedTokens'],
        queryFn: function () { return __awaiter(_this, void 0, Promise, function () {
            var payload, data;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, fetch('/api/explore/getListedTokens', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                    case 1:
                        payload = _c.sent();
                        return [4 /*yield*/, payload.json()];
                    case 2:
                        data = _c.sent();
                        setListedTokensLC((_a = data === null || data === void 0 ? void 0 : data.tokens) === null || _a === void 0 ? void 0 : _a.data_json);
                        return [2 /*return*/, (_b = data === null || data === void 0 ? void 0 : data.tokens) === null || _b === void 0 ? void 0 : _b.data_json];
                }
            });
        }); },
        refetchInterval: 60 * 1000,
    });
    var listedTokens = listedTokenLC || query.data;
    var _b = useMultiTokenData({
        tokens: listedTokens === null || listedTokens === void 0 ? void 0 : listedTokens.map(function (token) { return "".concat(token.token, ":").concat(token.chain); }),
    }), subMemeDataRaw = _b.data, subMemeLoading = _b.isLoading;
    // console.log('subMemeDataRaw', subMemeDataRaw, listedTokens);
    var subMemeData = subMemeDataRaw === null || subMemeDataRaw === void 0 ? void 0 : subMemeDataRaw.map(function (item) {
        var _a;
        //@todo: fix this, expensive operation
        return __assign(__assign({}, item), { category: (_a = listedTokens.find(function (token) { var _a, _b, _c; return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = item === null || item === void 0 ? void 0 : item.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()); })) === null || _a === void 0 ? void 0 : _a.category });
    }).sort(function (a, b) {
        var listedTokenIndexA = listedTokens.findIndex(function (token) { var _a, _b, _c; return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = a === null || a === void 0 ? void 0 : a.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()); });
        var listedTokenIndexB = listedTokens.findIndex(function (token) { var _a, _b, _c; return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = b === null || b === void 0 ? void 0 : b.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase()); });
        return listedTokenIndexA - listedTokenIndexB;
    });
    return { subMemeData: subMemeData, subMemeLoading: subMemeLoading, listedTokens: listedTokens };
}
